import React from 'react';
import './AnalyticsSection.css';

function AnalyticsSection() {
  return (
    <section className="pm-web-sec pm-web-analytics">
      <div className="pm-web-analytics-art" aria-hidden="true">
        <div className="pm-web-analytics-art__glow"></div>
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/prime/compliance-analytics.png`}
          alt=""
        />
      </div>

      <div className="pm-web-wrap">
        <div className="pm-web-analytics-copy">
          <span className="pm-web-eyebrow pm-reveal">Real-time compliance</span>
          <h2 className="pm-web-h2 pm-reveal" style={{ '--reveal-delay': '80ms' }}>
            Audit-ready, <em>every day of the project.</em>
          </h2>
          <p className="pm-web-lede pm-reveal" style={{ '--reveal-delay': '140ms' }}>
            Every inspection and report submitted on your project is reviewed by the AI against the full project context. Every finding, every fix, every outstanding issue tracked in one place, so your compliance health stays current at every moment.
          </p>

          <div className="pm-web-insights pm-web-insights--stack pm-reveal" style={{ '--reveal-delay': '220ms' }}>
            <div className="pm-web-insight">
              <div className="pm-web-insight__icon"><i className="bx bx-shield-quarter"></i></div>
              <div>
                <div className="pm-web-insight__title">Compliance Health</div>
                <p>The real-time status of your project against your compliance requirements. What's clean, what's flagged, and what's still outstanding, at a glance.</p>
              </div>
            </div>
            <div className="pm-web-insight">
              <div className="pm-web-insight__icon"><i className="bx bx-git-pull-request"></i></div>
              <div>
                <div className="pm-web-insight__title">Resolution Tracking</div>
                <p>Every finding traced from detection to closeout. Which technician was notified, what's been corrected, and what's still pending.</p>
              </div>
            </div>
            <div className="pm-web-insight">
              <div className="pm-web-insight__icon"><i className="bx bx-badge-check"></i></div>
              <div>
                <div className="pm-web-insight__title">Audit Readiness</div>
                <p>Documentation, signatures, certifications, and compliance records always current. The project closes clean and the audit is already done.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AnalyticsSection;
